import { getElementExists } from "../../../resources/js/helper/helper";

(function () {
  // Classes
  const accordionContainerClass = ".mb-filelist-accordion";
  const accordionControlClass = ".accordion-control";
  const accordionTextClass = ".mb-tab__text";
  const accordionTabClass = ".mb-filelist-accordion__tab";

  // Data-Attributes
  const tabActivData = "data-tab-active";

  let documentWidth = document.body.clientWidth;

  /**
   * Setup Accordion
   */
  function setupAccordion() {
    const accordionContainers = document.querySelectorAll(accordionContainerClass);

    accordionContainers.forEach(container => {
      const accordionControls = container.querySelectorAll(accordionControlClass);
      const accordionTabs = container.querySelectorAll(accordionTabClass);

      accordionControls.forEach((control, index) => {
        control.addEventListener("click", () => toggleTab(index, accordionTabs));
        control.addEventListener("keydown", event => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleTab(index, accordionTabs);
          }
        });
      });

      // Initial setup of tabindex for links
      updateTabIndex(accordionTabs);
    });
  }

  /**
   * Toggle tab state
   * @param {int} index
   * @param {NodeList} accordionTabs
   */
  function toggleTab(index, accordionTabs) {
    const tab = accordionTabs[index];
    const control = tab.querySelector(accordionControlClass);
    const content = tab.querySelector(accordionTextClass);
    const isExpanded = control.getAttribute("aria-expanded") === "true";

    // Toggle current tab
    control.setAttribute("aria-expanded", !isExpanded);
    content.setAttribute("aria-hidden", isExpanded);
    tab.setAttribute(tabActivData, !isExpanded);

    // Adjust max-height
    content.style.maxHeight = isExpanded ? "0px" : `${content.scrollHeight}px`;

    // Reset other tabs and update tabindex for links
    accordionTabs.forEach((otherTab, i) => {
      if (i !== index) {
        otherTab.setAttribute(tabActivData, "false");
        otherTab.querySelector(accordionControlClass).setAttribute("aria-expanded", "false");
        const otherContent = otherTab.querySelector(accordionTextClass);
        otherContent.setAttribute("aria-hidden", "true");
        otherContent.style.maxHeight = "0px";
      }
    });

    updateTabIndex(accordionTabs);
  }

  /**
   * Update tabindex for links in all tabs
   * @param {NodeList} accordionTabs
   */
  function updateTabIndex(accordionTabs) {
    accordionTabs.forEach(tab => {
      const content = tab.querySelector(accordionTextClass);
      const links = content.querySelectorAll("a");
      const isHidden = content.getAttribute("aria-hidden") === "true";

      links.forEach(link => {
        if (isHidden) {
          link.setAttribute("tabindex", "-1");
        } else {
          link.setAttribute("tabindex", "0");
        }
      });
    });
  }

  function resetTabsOnResize() {
    if (document.body.clientWidth !== documentWidth) {
      documentWidth = document.body.clientWidth;
      const allTabs = document.querySelectorAll(accordionTabClass);
      allTabs.forEach(tab => {
        tab.setAttribute(tabActivData, "false");
        tab.querySelector(accordionControlClass).setAttribute("aria-expanded", "false");
        const content = tab.querySelector(accordionTextClass);
        content.setAttribute("aria-hidden", "true");
        content.style.maxHeight = "0px";
      });
      updateTabIndex(allTabs);
    }
  }

  window.addEventListener("resize", resetTabsOnResize);

  setupAccordion();
})();
